import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiError } from "../AuthContext";
import GoogleButton from "../components/GoogleButton";
import AppHeader from "../components/AppHeader";
import SiteFooter from "../components/SiteFooter";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      const dest = location.state?.from?.pathname || "/app";
      navigate(dest, { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Sign-in failed. Try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page" data-testid="login-page">
      <div className="grain-bg" />
      <div className="container-narrow">
        <AppHeader />
        <div className="fade-in" style={{ maxWidth: 420, margin: "0 auto" }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Welcome back</div>
          <h1 className="display">Sign in.</h1>

          <form onSubmit={handleSubmit} className="form-stack" data-testid="login-form">
            <div>
              <label className="field-label" htmlFor="email">Email</label>
              <input
                id="email" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-line" placeholder="you@example.com"
                data-testid="login-email-input" autoComplete="email"
              />
            </div>
            <div>
              <label className="field-label" htmlFor="password">Password</label>
              <input
                id="password" type="password" required minLength={6}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-line" placeholder="••••••••"
                data-testid="login-password-input" autoComplete="current-password"
              />
            </div>

            {error && <div className="error-msg" data-testid="login-error">{error}</div>}

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, paddingTop: 8 }}>
              <button type="submit" className="btn-underline" disabled={loading} data-testid="login-submit-btn">
                {loading ? "Signing in…" : "Sign in →"}
              </button>
              <Link to="/forgot-password" className="nav-link" data-testid="forgot-password-link">
                Forgot?
              </Link>
            </div>
          </form>

          <div className="auth-divider">or</div>

          <GoogleButton>Continue with Google</GoogleButton>

          <div style={{ marginTop: 36, textAlign: "center", color: "var(--muted)", fontSize: 13 }}>
            <span className="serif-italic">New here? </span>
            <Link to="/register" className="nav-link" data-testid="goto-register" style={{ display: "inline" }}>
              Create an account
            </Link>
          </div>
        </div>
        <SiteFooter />
      </div>
    </div>
  );
}
